import {
  VStack,
  Button,
  Text,
  HStack,
  Icon,
  Box,
  Badge,
} from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@/client/components/shared/Modal';

interface EditMethodDialogProps {
  isOpen: boolean;
  onClose: () => void;
  orgId: string;
  chatbotId: string;
}

export const EditMethodDialog = ({ isOpen, onClose, orgId, chatbotId }: EditMethodDialogProps) => {
  const navigate = useNavigate();

  const handleMethodSelect = (path: string) => {
    navigate(path);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={'Edit Chatbot'}
      size="lg"
    >
      <VStack spacing={6} align="stretch">
        {/* Edit Button (V2 - default) */}
        <Button
          height="auto"
          p={{ base: 4, md: 6 }}
          onClick={() => handleMethodSelect(`/dashboard/${orgId}/workflows/${chatbotId}/edit-v4`)}
          variant="ghost"
          _hover={{
            bg: "interactive-hover",
            transform: "translateY(-2px)",
            shadow: "md",
          }}
          transition="all 0.2s"
          width="100%"
          display="block"
        >
          <HStack
            spacing={4}
            align="flex-start"
            width="100%"
          >
            <Icon
              as={MdEdit}
              boxSize={{ base: 5, md: 6 }}
              color="green.500"
              flexShrink={0}
            />
            <Box flex={1}>
              <HStack spacing={2} mb={1}>
                <Text
                  fontWeight="bold"
                  color="text-primary"
                  fontSize={{ base: "sm", md: "md" }}
                  textAlign="left"
                  noOfLines={1}
                >
                  Update Tasks
                </Text>
                <Badge colorScheme="green" fontSize="2xs">New</Badge>
              </HStack>
              <Text
                fontSize={{ base: "xs", md: "sm" }}
                color="text-secondary"
                textAlign="left"
                noOfLines={3}
                wordBreak="break-word"
                whiteSpace="pre-wrap"
              >
                Edit this chatbot's tasks using the new editor
              </Text>
            </Box>
          </HStack>
        </Button>
      </VStack>
    </Modal>
  );
};
